//@flow
import shortid from 'shortid'
export type ComparismType = 'equals' | 'unequals' | 'includes'

class Filter {
  id: string
  column: string
  type: ComparismType
  label: string
  value: string
  isDisabled: boolean

  constructor({
    id = shortid(),
    isDisabled = false,
    type,
    value,
    column
  }: {
    id?: string,
    isDisabled?: boolean,
    type: ComparismType,
    value: string,
    column: string
  }) {
    this.id = id
    this.column = column
    this.type = type
    this.value = value
    this.isDisabled = isDisabled
  }
}

export { Filter }
